export default __webpack_public_path__ + "static/media/radovan_m.9ea80251.jpg";